
import React, { useEffect, useState } from 'react';
import { FAQsListingAction } from '../../../features/webCommonSlice';
import Accordion from 'react-bootstrap/Accordion';
import "./FAQ.scss";
import NoDataFound from '../../Components/NoDataFound/NoDataFound';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const FAQs = () => {
    // const [loader, setLoader] = useState(false)
    // const [faqListing, setFAQsListing] = useState([]);

    // useEffect(() => {
    //     setLoader(true)
    //     FAQsListingAction((response) => {
    //         if (response?.status === true) {
    //             setFAQsListing(response?.data)
    //         }
    //         setLoader(false)
    //     })();
    // }, [FAQsListingAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'> Frequently Asked Questions </div>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            {/* {!loader ?
                                faqListing?.length > 0 ?
                                    <Accordion defaultActiveKey={0}>
                                        {faqListing?.map((value, index) => (
                                            <Accordion.Item key={index} eventKey={index} alt={index}>
                                                <Accordion.Header> {value?.question} </Accordion.Header>
                                                <Accordion.Body> {value?.answer} </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                    :
                                    <NoDataFound />
                                :
                                <>
                                    <CmsPageShimmer />
                                </>
                            } */}

                            <Accordion defaultActiveKey="0">
                                <Accordion.Item key="0" eventKey="0" alt="0">
                                    <Accordion.Header>  Why is GST been charged on Add cash?</Accordion.Header>
                                    <Accordion.Body>As per GST law, effective from 1st October’23, GST @28% is applicable on any amount deposited by user’s in any gaming platform and hence Millionaire11 need to charge GST @28% on the amount deposited by user’s through normal banking channels.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="1" eventKey="1" alt="1">
                                    <Accordion.Header>  How is GST calculated?</Accordion.Header>
                                    <Accordion.Body>For instance, a player deposits ₹100 on an online gaming platform. That player will receive only ₹78.12 in their account after a 28% GST deduction of ₹21.88. Further a cashback of Rs 21.88 will be instantly credited to his deposit wallet which is freely usable in the platform.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="2" eventKey="2" alt="2">
                                    <Accordion.Header>What is the TDS policy?</Accordion.Header>
                                    <Accordion.Body>The policy:

                                        From 1st April’23, the Income tax department has introduced a new TDS section for Winnings from online games, i.e., 194BA. The net winnings are calculated at the time when a user places a request for withdrawal (or at the year-end on the closing balance), and TDS is calculated as 30% of the net winnings that constitute the Withdrawal/ Closing Balance at the year-end.

                                        Important points:

                                        - The TDS will be deducted at the time of withdrawal.
                                        - The TDS will be applicable only on net winnings that constitute withdrawals and not deposits.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="3" eventKey="3" alt="3">
                                    <Accordion.Header>How many teams can I create for a single contest?</Accordion.Header>
                                    <Accordion.Body>Maximum team creation varies in accordance with the contest category. For instance, a user can create a maximum of 100 teams in a Grand League contest.</Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="4" eventKey="4" alt="4">
                                    <Accordion.Header> How do I join a contest?</Accordion.Header>
                                    <Accordion.Body>To join contests, click on a contest on the contest listing page and click on “Register team” to join the contest.</Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FAQs